var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 44.1663C23.9083 42.3813 26.8408 41.333 30 41.333C33.1592 41.333 36.0917 42.3813 38.5 44.1663",
    stroke: "#FF5E41",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4998 30C40.0646 30 41.3332 28.0972 41.3332 25.75C41.3332 23.4028 40.0646 21.5 38.4998 21.5C36.935 21.5 35.6665 23.4028 35.6665 25.75C35.6665 28.0972 36.935 30 38.4998 30Z",
    fill: "#FF5E41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 30C23.0646 30 24.3332 28.0972 24.3332 25.75C24.3332 23.4028 23.0646 21.5 21.4998 21.5C19.935 21.5 18.6665 23.4028 18.6665 25.75C18.6665 28.0972 19.935 30 21.4998 30Z",
    fill: "#FF5E41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.6665 29.9998C1.6665 16.6435 1.6665 9.96534 5.8145 5.8145C9.96817 1.6665 16.6435 1.6665 29.9998 1.6665C43.3562 1.6665 50.0343 1.6665 54.1823 5.8145C58.3332 9.96817 58.3332 16.6435 58.3332 29.9998C58.3332 43.3562 58.3332 50.0343 54.1823 54.1823C50.0372 58.3332 43.3562 58.3332 29.9998 58.3332C16.6435 58.3332 9.96534 58.3332 5.8145 54.1823C1.6665 50.0372 1.6665 43.3562 1.6665 29.9998Z",
    stroke: "#FF5E41",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.5ef7d9d207eb50105bb7ea51563d1019.svg";
export { ForwardRef as ReactComponent };